import React from 'react';
import './FooterCTA.css';

const FooterCTA = () => {
  return (
    <div className="footer-cta">
      <div className="arrow-banner">
        <h2>ÚNETE AL GRUPO THE BULL MINER</h2>
        <div className="arrow-shape"></div>
      </div>
      
      <div className="cta-content">
        <h3>CURSOS GRATIS DE <span className="text-blue">GEOLOGÍA</span> Y <span className="text-green">MINERÍA + IA</span></h3>
        <h2 className="phone-number">ESCRIBEME AL +51 963462787</h2>
        <p className="sub-cta">ASESORAMIENTO GRATIS DE 20 MIN EN TUS PROYECTOS</p>
        
        <a href="https://wa.me/51963462787" className="btn-whatsapp">
          Contactar por WhatsApp
        </a>
      </div>
    </div>
  );
};
export default FooterCTA;